import React, { useEffect, useState } from 'react';
import DayPopup from './DayPopup'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [events, setEvents] = useState({});
  const [selectedDayEvents, setSelectedDayEvents] = useState([]);
  const [popupDate, setPopupDate] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await fetch('https://us-central1-indian-park.cloudfunctions.net/getCalendarEvents');
        const data = await res.json();

        const grouped = {};
        data.forEach(event => {
          if (!grouped[event.date]) {
            grouped[event.date] = [];
          }
          grouped[event.date].push(event);
        });

        setEvents(grouped);
      } catch (err) {
        console.error('Error fetching events:', err);
      }
    };

    fetchEvents();
  }, []);

  const getDaysInMonth = (year, month) => new Date(year, month + 1, 0).getDate();
  const getFirstDayOfMonth = (year, month) => new Date(year, month, 1).getDay();

  const handlePrevMonth = () => {
    setCurrentDate(prev => new Date(prev.getFullYear(), prev.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(prev => new Date(prev.getFullYear(), prev.getMonth() + 1, 1));
  };

  const handleDayClick = (day) => {
    if (!day) return;
  
    const fullDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day)
      .toISOString()
      .split('T')[0]; // Format: YYYY-MM-DD
  
    const eventsForDay = events[fullDate] || [];
  
    if (eventsForDay.length) {
      setSelectedDayEvents(eventsForDay);
      setPopupDate(fullDate);
    }
  };
  

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const daysInMonth = getDaysInMonth(year, month);
  const firstDay = getFirstDayOfMonth(year, month);

  const days = [];
  for (let i = 0; i < firstDay; i++) days.push(null);
  for (let i = 1; i <= daysInMonth; i++) days.push(i);
  while (days.length < 42) days.push(null);

  const weeks = [];
  while (days.length) weeks.push(days.splice(0, 7));

  return (
    <div className="community-calendar">
      <div className="calendar-toolbar">
        <button className="calendar-nav" onClick={handlePrevMonth} aria-label="Previous month"><FiChevronLeft /> Previous</button>
        <h2>{currentDate.toLocaleString('default', { month: 'long' })} {year}</h2>
        <button className="calendar-nav" onClick={handleNextMonth} aria-label="Next month">Next <FiChevronRight /></button>
      </div>

      <table className="calendar-grid">
        <thead>
          <tr>
            {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(day => (
              <th key={day}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                const fullDate = day ? `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}` : null;
                const dayEvents = fullDate ? events[fullDate] || [] : [];

                return (
                  <td onClick={() => handleDayClick(day)} key={di} className={`calendar-cell ${day ? 'has-day' : ''}`}>
                    <div className="calendar-day-number">{day || ''}</div>
                    <div>
                      {dayEvents.slice(0, 3).map((evt, i) => (
                        <div
                          key={i}
                          title={`${evt.time} - ${evt.title}`}
                          className="calendar-event"
                          style={{ backgroundColor: evt.color }}
                        >
                          {evt.title}
                        </div>
                      ))}
                      {dayEvents.length > 3 && (
                        <div className="calendar-more">+{dayEvents.length - 3} more</div>
                      )}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
      {popupDate && (
        <DayPopup
          date={popupDate}
          events={selectedDayEvents}
          onClose={() => setPopupDate(null)}
        />
      )}
    </div>
    
  );
};

export default Calendar;
